var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    style: {
      "--color": _vm.styleObj.buttonInfo[0].buttonBgColor
    }
  }, [_c("div", {
    staticClass: "premiumBox"
  }, [_c("div", {
    staticStyle: {
      height: "330px",
      "overflow-y": "auto"
    }
  }, [_c("div", {
    staticClass: "contBox"
  }, [_c("div", [_vm._v(_vm._s(_vm.$t("被保人生日"))), _c("a-icon", {
    attrs: {
      type: "right"
    }
  })], 1), _c("div", [_vm._v(" " + _vm._s(_vm.$t("保障额度")) + " "), _c("div", {
    staticClass: "planBox"
  }, _vm._l(_vm.list, function (item, index) {
    return _c("div", {
      key: index,
      class: index == _vm.tabIndex ? "hit" : "",
      style: "color:" + (index == _vm.tabIndex ? _vm.styleObj.buttonInfo[0].buttonFontColor : "")
    }, [_vm._v(" " + _vm._s(item.value) + " ")]);
  }), 0)])]), _c("div", {
    staticClass: "additional-show"
  }, [_c("div", {
    staticClass: "name",
    staticStyle: {
      "padding-bottom": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t("附加险")))]), _c("div", {
    staticClass: "additional-show1"
  }, [_c("div", {
    staticClass: "production"
  }, [_c("span", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("产品名称")))]), _c("span", {
    staticClass: "right"
  }, [_vm._v("2" + _vm._s(_vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId)) + _vm.$t("/人")))])]), _c("div", {
    staticStyle: {
      color: "#a0a0a0",
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.$t("保障金额")) + "：" + _vm._s(_vm.$t("20万")))]), _c("span", {
    staticClass: "icon"
  }, [_vm._v(_vm._s(_vm.$t("必购")))])]), _c("div", {
    staticClass: "additional-show2"
  }, [_c("div", {
    staticClass: "production"
  }, [_c("span", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("产品名称")) + _vm._s(_vm.$t("产品名称")) + _vm._s(_vm.$t("产品名称")) + _vm._s(_vm.$t("产品名称")) + _vm._s(_vm.$t("产品名称")))]), _c("span", {
    staticClass: "right"
  }, [_vm._v("2" + _vm._s(_vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId)) + _vm.$t("/人")))])]), _c("div", [_c("span", {
    staticClass: "btn-money",
    style: "color:" + _vm.styleObj.buttonInfo[0].buttonFontColor + ";background-color:" + _vm.styleObj.buttonInfo[0].buttonBgColor
  }, [_vm._v(_vm._s(_vm.$t("20万")))]), _c("span", {
    staticClass: "btn-money",
    staticStyle: {
      "background-color": "#ebebeb",
      color: "#000"
    }
  }, [_vm._v(_vm._s(_vm.$t("30万")))])]), _c("span", {
    staticClass: "icon"
  }, [_vm._v("✔️")])])]), _c("div", [_c("div", {
    staticClass: "name",
    staticStyle: {
      "padding-left": "15px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t("保障权益")))]), _c("div", {
    staticClass: "contBox2"
  }, _vm._l(_vm.list, function (item, index) {
    return _c("div", {
      key: index
    }, [_c("div", {
      staticClass: "infoBox"
    }, [_c("span", {
      style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]), _c("div", {
      staticClass: "right"
    }, [_c("span", {
      style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
    }, [_vm._v(_vm._s(_vm.$t(item.value)))]), item.info ? _c("div", {
      style: "color:" + _vm.themeColor,
      on: {
        click: function ($event) {
          $event.stopPropagation();
          return _vm.infoClickFun(index);
        }
      }
    }, [!item.isClick ? _c("a-icon", {
      attrs: {
        type: "down"
      }
    }) : _c("a-icon", {
      attrs: {
        type: "up"
      }
    })], 1) : _vm._e()])]), item.isClick ? _c("div", {
      staticClass: "info"
    }, [_vm._v(_vm._s(_vm.$t(item.info)))]) : _vm._e()]);
  }), 0)])]), _c("div", {
    staticClass: "btn3"
  }, [_c("div", {
    staticClass: "left",
    style: "color:" + _vm.styleObj.buttonInfo[0].buttonBgColor
  }, [_vm._v("222")]), _vm.styleObj.buttonInfo[0] ? _c("div", {
    staticClass: "right",
    style: "color:" + _vm.styleObj.buttonInfo[0].buttonFontColor + ";background:" + _vm.styleObj.buttonInfo[0].buttonBgColor,
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.$emit("premiumClick", 0);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.styleObj.buttonInfo[0].buttonName || _vm.$t("按钮文案")) + " ")]) : _vm._e()])])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };